import React from 'react'
import BaseField from './BaseField'


export default function FieldDisplay(props) {
  /* Input

    for use with useForm()
    used to display a solid value in useForm

   */

  // RENDER
  return (
    <BaseField
      className={props.className ? props.className : ''}
      labelClassName={props.labelClassName}
      inputClassName={props.inputClassName}
      label={props.label}
      input={(
        <div className='pt-2'>
          {props.display}
        </div>
      )}
      prepend={props.prepend}
      append={props.append}
      disabled={props.disabled}
      readOnly={props.readOnly}
      required={props.required}
      valid={props.valid}
      validMessage={props.validMessage}
      invalidMessage={props.invalidMessage}
      help={props.help}
      helpAboveInput={props.helpAboveInput}
      horizontal={props.horizontal}
      horizontalLabelSize={props.horizontalLabelSize}
    />
  )
}
